export function teamReview(args = {}) {
  const {
    showLinkTeamModal = false,
    teamListUrl,
    unlinkTeamUrl,
    linkTeamUrl,
    stageImportUrl,
    publishImportUrl,
    showUnlinkIntroJs,
  } = args;

  return {
    // Modal and UI state
    showLinkTeamModal: showLinkTeamModal,
    showConfirmImportModal: false,

    // Import settings
    accountHasRetroactivelyAppliableSnapshot: false,
    importShouldApplyToRetroactivelyAppliableSnapshot: null,

    // Team linking state
    teamToLink: null,
    existingTeams: [],
    filteredExistingTeams: [],
    teamSearchQuery: "",
    teamListUrl,
    unlinkTeamUrl,
    linkTeamUrl,
    stageImportUrl,
    publishImportUrl,
    init() {
      if (showUnlinkIntroJs) {
        setTimeout(() => {
          let steps = [
            {
              element: document.querySelector(".x-team-unlink"),
              intro:
                "If a team was incorrectly matched, click here to remove the match and create a new team instead",
            },
          ];

          window
            .introJs()
            .setOptions({
              exitOnEsc: false,
              exitOnOverlayClick: false,
              doneLabel: "Got it",
              scrollToElement: true,
              disableInteraction: true,
              steps,
            })
            .start()
            .oncomplete(() => {
              window.ack("org_csv_unlink");
            });
        }, 50);
      }
    },

    unlinkTeam(team) {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = this.unlinkTeamUrl;

      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);

      const tempIdInput = document.createElement("input");
      tempIdInput.type = "hidden";
      tempIdInput.name = "temp_id";
      tempIdInput.value = team.temp_id;
      form.appendChild(tempIdInput);

      document.body.appendChild(form);
      form.submit();
    },

    async openLinkTeamModal(team) {
      this.teamToLink = team;
      this.showLinkTeamModal = true;
      this.teamSearchQuery = "";

      try {
        const response = await fetch(this.teamListUrl, {
          headers: {
            Accept: "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
              .content,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch teams");
        const data = await response.json();
        this.existingTeams = data;
        this.filteredExistingTeams = data;
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    },

    filterTeams() {
      if (!this.teamSearchQuery) {
        this.filteredExistingTeams = this.existingTeams;
        return;
      }

      const query = this.teamSearchQuery.toLowerCase();
      this.filteredExistingTeams = this.existingTeams.filter(
        (team) =>
          team.name.toLowerCase().includes(query) ||
          (team.parent_team_name &&
            team.parent_team_name.toLowerCase().includes(query)) ||
          (team.manager_email &&
            team.manager_email.toLowerCase().includes(query)),
      );
    },

    selectTeamToLink(existingTeam) {
      this.linkTeam(this.teamToLink, existingTeam);
      this.showLinkTeamModal = false;
      this.teamToLink = null;
      this.teamSearchQuery = "";
    },

    linkTeam(teamToLink, existingTeam) {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = this.linkTeamUrl;

      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);

      const tempIdInput = document.createElement("input");
      tempIdInput.type = "hidden";
      tempIdInput.name = "temp_id";
      tempIdInput.value = teamToLink.temp_id;
      form.appendChild(tempIdInput);

      const existingTeamIdInput = document.createElement("input");
      existingTeamIdInput.type = "hidden";
      existingTeamIdInput.name = "existing_team_id";
      existingTeamIdInput.value = existingTeam.id;
      form.appendChild(existingTeamIdInput);

      document.body.appendChild(form);
      form.submit();
    },

    formatDate(date) {
      return date ? new Date(date).toLocaleString() : "";
    },

    stageImport() {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = this.stageImportUrl;

      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);

      document.body.appendChild(form);
      form.submit();
    },

    showConfirmImport() {
      this.showConfirmImportModal = true;
    },

    publishImport() {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = this.publishImportUrl;

      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);

      if (
        this.accountHasRetroactivelyAppliableSnapshot &&
        this.importShouldApplyToRetroactivelyAppliableSnapshot !== null
      ) {
        const retroInput = document.createElement("input");
        retroInput.type = "hidden";
        retroInput.name = "apply_retroactively";
        retroInput.value =
          this.importShouldApplyToRetroactivelyAppliableSnapshot;
        form.appendChild(retroInput);
      }

      document.body.appendChild(form);
      form.submit();
    },
  };
}
